import { Link } from 'react-router-dom';

const columns = [
  {
    title: '浏览内容',
    links: [
      { label: '最新电影', to: '/category?type=movie&sort=latest' },
      { label: '热播电视剧', to: '/category?type=tv&sort=hot' },
      { label: '高分佳作', to: '/category?type=movie&sort=rating' },
      { label: '影视资讯', to: '/#news' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '使用说明', to: '/about#usage' },
      { label: '版权声明', to: '/about#copyright' },
      { label: '联系我们', to: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto w-full max-w-portal px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-primary-950">
                <i className="ri-leaf-fill" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">青青草</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              青青草是一个专注电影与电视剧内容的影视资源平台，我们整理作品资料、聚合影视资讯，帮助每一位观众更快找到想看的那一部。
            </p>
            <p className="mt-5 max-w-sm text-xs leading-relaxed text-background-500">
              本站为演示站点，不提供真实播放、下载与会员服务，所有作品信息均为虚构演示数据。
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title} className="md:col-span-2">
              <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">
                <span>{column.title}</span>
              </h4>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="cursor-pointer text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">
              <span>友情链接</span>
            </h4>
            <div className="flex flex-wrap gap-2">
              {['光影资料馆', '剧集观察局', '影像档案馆', '放映笔记'].map((name) => (
                <span
                  key={name}
                  className="rounded-full border border-background-500/30 px-3 py-1 text-xs text-background-300"
                >
                  {name}
                </span>
              ))}
            </div>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-400">
              <i className="ri-mail-line text-base" />
              <span>hello@qingqingcao.example</span>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-500/25 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 青青草 影视资源平台 · 内容仅供演示与学习使用</span>
          <span className="flex items-center gap-4">
            <span>本站数据均为模拟数据</span>
            <span className="hidden sm:inline">Designed for film lovers</span>
          </span>
        </div>
      </div>
    </footer>
  );
}